export type SettingCode = 'ORDER_TAB_FEATURE' | 'SALES_TAB_FEATURE' | 'ORDER_SORT_FEATURE' | 'SALES_SORT_FEATURE'

type SettingCodeMap = Record<SettingCode, SettingCode>

export const SETTING_CODE: SettingCodeMap = {
  ORDER_TAB_FEATURE: 'ORDER_TAB_FEATURE', // 运单TAB页配置
  SALES_TAB_FEATURE: 'SALES_TAB_FEATURE', // 订单TAB页配置
  ORDER_SORT_FEATURE: 'ORDER_SORT_FEATURE', // 运单排序
  SALES_SORT_FEATURE: 'SALES_SORT_FEATURE', //  订单排序
}
